/**
 * 
 * @copyright     (c) 2025-2026 Gist Applications Inc.
 * @author        Greg Olive greg@gist-apps.com
 * @package       gift-card-pro
 * 
 * /assets/js/React/Proxy/pages/GiftCardForm/_sections/VideoMessage.js
 * Created:       Tue May 27 2025
 * Modified By:   Greg Olive
 * Last Modified: Tue Oct 20 2026
 */

import React, {useState, useEffect, useContext} from 'react';
import { TranslationsContext, FormContext } from '../../../_contexts';
import { ImageButton, FormSection, LabelButton } from "../../../_components";
import { InlineError } from '@shopify/polaris';
import { generateVideoThumbnail } from "@proxy/_utils";
import VideoSolidIcon from "~/assets/images/icons/fontAwesome/video-solid.svg";
export default function VideoMessage() {

  const translations = useContext(TranslationsContext);
  const {
    settings,
    formData,
    formErrors,
    updateFormField,
    setEnableCamera,
    handleRecordingComplete,
  }  = useContext(FormContext);

  const storageSpace = settings.files.storage.available;

  const [loading, setLoading] = useState(false);

  const mobileScreenWidth = 576;
  const isMobile = screen.width < mobileScreenWidth;
  const fileExtension = navigator.vendor.includes("Apple") ? "mp4" : "webm";

  const hasVideoError = formErrors._gcp_video_id && formErrors._gcp_video_id.error === true;
  const videoErrorMarkup = hasVideoError && (<p className={"gc__input_field_error_message"}>{ formErrors._gcp_video_id.message }</p>);

  const hasImageError = formErrors._gcp_thumbnail_image && formErrors._gcp_thumbnail_image.error === true;
  const imageErrorMarkup = hasImageError && (<p className={"gc__input_field_error_message"}>{ formErrors._gcp_thumbnail_image.message }</p>);

  /**
   * Handles a video recording on mobile;
   */
  const handleInputChange = async (input) => {

    setLoading(true);

    const inputFile = input.target.files[0];

    const url = URL.createObjectURL(inputFile);

    // Always overwrite so a previous video's thumbnail is never kept
    const thumbnail = await generateVideoThumbnail(url);

    updateFormField("properties._gcp_thumbnail_image", thumbnail);

    await handleRecordingComplete(url, true);

    setLoading(false);

  }

  const videoInputMarkup = (
    isMobile ?
      <LabelButton
        label={loading == true ? translations.loading_video : formData.properties._gcp_video_id != "" ? translations.edit_video : translations.take_video}
        image={VideoSolidIcon}
        onChange={(e) => handleInputChange(e)}
        loading={loading}
      /> :
      <ImageButton
        label={formData.properties._gcp_video_id != "" ? translations.edit_video : translations.take_video}
        subdued={true}
        onClick={() => {
          setEnableCamera(true);
          MicroModal.show('gcpVideoRecordingModal', {
            onClose: () => setEnableCamera(false)
          });
        }}
        image={formData.properties._gcp_thumbnail_image !== "" && hasVideoError == false ? formData.properties._gcp_thumbnail_image : VideoSolidIcon}
        id="gcpOpenVideoModal"
        type={"button"}
      />
  );

  const videoMessageMarkup = (
    <div className={"gc__media_button_container"}>
      <label className="gc__input_label">
        {translations.send_media_label}
      </label>
      <br/>

      { videoInputMarkup }
      { videoErrorMarkup }
      { imageErrorMarkup }

      {formData.properties._gcp_video_id !== "" && (
        <>
          <br/>
          <a
            onClick={() => {
              updateFormField("properties._gcp_thumbnail_image", "");
              updateFormField("properties._gcp_video_id", "");
              updateFormField("fields._gcp_helper_video", "");
            }}
            href="#"
          >
            {translations.remove_video}
          </a>
        </>
      )}
      <input
        type="hidden"
        name="properties[_gcp_video_id]"
        value={formData.properties._gcp_video_id}
        onChange={() => {}}
      />
      <input
        type="hidden"
        name="properties[_gcp_thumbnail_image]"
        value={formData.properties._gcp_thumbnail_image}
        onChange={() => {}}
      />
    </div>
  );

  return (
    <>
      {
        storageSpace / 1000000 < 10 ?
        <></> :
        <FormSection>
          <div className={"gc__message_details_div"}>
            {videoMessageMarkup}
          </div>
        </FormSection>
      }
    </>
  );
};
